import { DragDropContext as DragDropContextOld, Droppable as DroppableOld, Draggable as DraggableOld } from 'react-beautiful-dnd';

export type { DropResult } from 'react-beautiful-dnd';

// 解决 react-beautiful-dnd 类型错误
const DragDropContext: any = DragDropContextOld;
const Droppable: any = DroppableOld;
const Draggable: any = DraggableOld;

export { DragDropContext, Droppable, Draggable };
